import { type Banner, BANNER_CONFIG, DAYS_LEFT_KEY, TRIAL_BANNER_TYPE } from "./trialBannerConfig";
import type { Translate } from "app/filters/i18nFilter";
import { getDaysLeft, isAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import type { ISwSettings } from "app/@types/ISwSettings";

export const getCTATextKey = (bannerType: Banner): string | null => {
    if (!bannerType) {
        return null;
    }

    const config = BANNER_CONFIG[bannerType];
    const ctaTextKey = config?.ctaTextKey;

    if (!ctaTextKey) {
        return null;
    }

    return ctaTextKey;
};

export const getDaysLeftTranslationKey = (daysLeft: number): string =>
    `${DAYS_LEFT_KEY}.${daysLeft > 1 ? "plural" : "single"}`;

export const shouldShowCTA = (bannerType: Banner): boolean =>
    bannerType !== null && !!BANNER_CONFIG[bannerType]?.ctaTextKey;

export const isShopperICPBanner = (bannerType: Banner): boolean => bannerType === TRIAL_BANNER_TYPE.SHOPPER_ICP;

export const getBannerText = (bannerType: Banner, i18n: Translate, swSettings: ISwSettings): string | null => {
    if (!bannerType) {
        return null;
    }

    const config = BANNER_CONFIG[bannerType];

    if (isShopperICPBanner(bannerType)) {
        return i18n(config.textKey);
    }

    const daysLeft = getDaysLeft(swSettings);
    const isTrialEnd = isAfterTrial(swSettings) && daysLeft < 1;

    const daysLeftTranslationKey = getDaysLeftTranslationKey(daysLeft);
    const daysLeftText =
        !isTrialEnd && daysLeft > 0 ? i18n(daysLeftTranslationKey, { number: String(daysLeft) }) : null;

    return `${daysLeftText ? daysLeftText + " " : ""}${i18n(config.textKey)}`;
};
